var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Clicks "),_c('info-tooltip',{attrs:{"content":"The number of times an ad creative was clicked"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }